import { render, staticRenderFns } from "./ConsultReply.vue?vue&type=template&id=253f3629&"
import script from "./ConsultReply.vue?vue&type=script&lang=js&"
export * from "./ConsultReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports